var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          !_vm.esEdicion
                            ? _vm.closeModal(false)
                            : (_vm.dialogConfirmacionClose = true)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          Baja Comercial " +
                        _vm._s(_vm.data.nombre_baja) +
                        "\n        "
                    )
                  ]),
                  _c("v-spacer"),
                  _vm.esEdicion && !_vm.bajaFinalizada
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar",
                          staticStyle: {
                            "min-width": "80px",
                            "max-width": "150px"
                          },
                          attrs: { depressed: "" },
                          on: {
                            click: function($event) {
                              return _vm.confirmSave()
                            }
                          }
                        },
                        [_vm._v("Guardar")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { align: "left" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md12: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "", md12: "" } },
                                          [
                                            _c(
                                              "v-tabs",
                                              {
                                                staticClass:
                                                  "attentions_modal_tabs"
                                              },
                                              [
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "general"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Baja Comercial\n                        "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "detalle"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Lista de Dispositivos\n                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        !_vm.loading
                                          ? _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  sm12: "",
                                                  md12: "",
                                                  "mt-5": ""
                                                }
                                              },
                                              [
                                                _vm.step === "general"
                                                  ? _c("TabGeneral", {
                                                      ref: "guardar",
                                                      attrs: {
                                                        data: _vm.data,
                                                        esEdicion:
                                                          _vm.esEdicion,
                                                        bajaFinalizada:
                                                          _vm.bajaFinalizada,
                                                        tramos: _vm.tramos
                                                      },
                                                      on: {
                                                        close: _vm.handleClosed
                                                      }
                                                    })
                                                  : _vm.step === "detalle" &&
                                                    _vm.dataApi.detalles
                                                      .length > 0
                                                  ? _c("TabDetalle", {
                                                      attrs: {
                                                        data:
                                                          _vm.dataApi.detalles
                                                      }
                                                    })
                                                  : _c("GridComponent", {
                                                      staticClass:
                                                        "ag-theme-material",
                                                      staticStyle: {
                                                        height: "220px"
                                                      },
                                                      attrs: {
                                                        "grid-options":
                                                          _vm.gridOptions
                                                      }
                                                    })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("br")
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm.esEdicion
        ? _c("app-confirmacion", {
            attrs: {
              show: _vm.dialogConfirmacionClose,
              titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
              mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
              textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
              textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
            },
            on: {
              modalConfirmationEmit: function($event) {
                return _vm.confirmCallbackConfirm($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }